var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fade-in",attrs:{"id":"overlay"}},[_c('div',{staticClass:"spinner"}),_c('br'),_vm._v("\n  "+_vm._s(_vm._T(_vm.status))+"...\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }